import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

import '@rainbow-me/rainbowkit/styles.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiProvider } from 'wagmi';
import { RainbowKitProvider, darkTheme } from '@rainbow-me/rainbowkit';
import { config } from './config/wagmi';
import { BACKEND_URL } from './config/api';

// Environment validation and logging (development only)
if (import.meta.env.DEV) {
  console.log('═══════════════════════════════════════════════════');
  console.log('🚀 BAPES Bridge - Startup Environment Check');
  console.log('═══════════════════════════════════════════════════');
  console.log('Mode:', import.meta.env.MODE);
  console.log('Backend URL:', BACKEND_URL);
  console.log('VITE_BACKEND_URL set:', !!import.meta.env.VITE_BACKEND_URL);
}

// Validate critical configuration
if (!BACKEND_URL || BACKEND_URL.includes('<') || BACKEND_URL === 'undefined') {
  console.error('═══════════════════════════════════════════════════');
  console.error('❌ CONFIGURATION ERROR');
  console.error('═══════════════════════════════════════════════════');
  console.error('BACKEND_URL is not properly configured:', BACKEND_URL);
  console.error('');
  console.error('For production deployments:');
  console.error('1. Set VITE_BACKEND_URL in your hosting platform');
  console.error('2. Redeploy the application');
  console.error('═══════════════════════════════════════════════════');
}

if (import.meta.env.DEV) {
  console.log('═══════════════════════════════════════════════════');
}

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider
          theme={darkTheme({
            accentColor: '#8B5CF6',
            accentColorForeground: '#ffffff',
            borderRadius: 'medium',
          })}
        >
          <App />
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>,
)
